export const PERMISSION_ACTIONS = ['view', 'add', 'edit', 'delete', 'approve', 'export', 'import'];

export const MODULES = [
  { id: 'dashboard', name: 'Dashboard', href: '/dashboard' },
  { id: 'employees', name: 'Employees', href: '/employees' },
  { id: 'users', name: 'User Management', href: '/users' },
  { id: 'masters', name: 'Masters', href: '/masters' },
  { id: 'attendance', name: 'Attendance', href: '/attendance' },
  { id: 'leaves', name: 'Leave Management', href: '/leaves' },
  { id: 'holidays', name: 'Holidays', href: '/holidays' },
  { id: 'salary-structure', name: 'Salary Structure', href: '/salary-structure' },
  { id: 'payroll', name: 'Payroll Administration', href: '/payroll' },
  { id: 'payroll-reports', name: 'Payroll Reports', href: '/payroll-reports' },
  { id: 'payslips', name: 'Payslips', href: '/payslips' },
  { id: 'reports', name: 'Reports', href: '/reports' },
  { id: 'info-hub', name: 'Info Hub', href: '/info-hub' },
  { id: 'company-settings', name: 'Company Settings', href: '/company-settings' }
];

export const moduleById = MODULES.reduce((acc, module) => {
  acc[module.id] = module;
  return acc;
}, {});

export const hasModuleAccess = (user, moduleId, action = 'view') => {
  if (!moduleId) return true;
  // The dashboard is the landing page for every signed-in company user.
  if (user && moduleId === 'dashboard' && action === 'view') return true;
  if (user?.is_super_admin) return true;

  const allowedModules = user?.allowed_modules;
  // Personal payslips also work with older company/session module lists.
  // Explicit role/user denials below remain authoritative.
  if (moduleId !== 'payslips' && Array.isArray(allowedModules) && !allowedModules.includes(moduleId)) {
    return false;
  }

  const permissions = user?.permissions;
  if (!permissions || Object.keys(permissions).length === 0) {
    if (moduleId === 'payslips') return ['view', 'export'].includes(action);
    if (['salary-structure', 'payroll', 'payroll-reports'].includes(moduleId)) {
      return ['Admin', 'HR'].includes(user?.role) || user?.department === 'HR' || user?.division === 'HR';
    }
    return true;
  }
  if (moduleId === 'payroll-reports' && !Object.prototype.hasOwnProperty.call(permissions, moduleId)) return ['Admin', 'HR'].includes(user?.role) || user?.department === 'HR' || user?.division === 'HR';
  if (moduleId === 'payslips' && !Object.prototype.hasOwnProperty.call(permissions, moduleId)) return ['view', 'export'].includes(action);
  return permissions[moduleId]?.includes(action);
};

export const hasLeaveFeature = (user, featureId) => {
  if (!featureId) return true;
  if (user?.is_super_admin) return true;
  const leaveFeatures = user?.leave_features;
  if (!leaveFeatures || Object.keys(leaveFeatures).length === 0) {
    return true;
  }
  return leaveFeatures[featureId] !== false;
};

export const hasAttendanceFeature = (user, featureId) => {
  if (!featureId) return true;
  if (user?.is_super_admin) return true;
  return user?.attendance_features?.[featureId] === true;
};
